/**
 * AT Home Lens Promo — scroll parallax (samsung-collection promo kopyası)
 */
(function () {
  function initScrollPromo(section) {
    var main = section.querySelector('[data-at-scroll-rows]');
    if (!main) return;

    var rows = main.querySelectorAll('.at-sam-col__promo-row');
    if (!rows.length) return;

    var parallax = parseFloat(section.dataset.parallax || '1.5');
    var maxTranslate = (-1 * parallax * 100) / (1 + parallax);

    function updateScroll() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height + vh;
      var scrolled = vh - rect.top;
      var progress = total > 0 ? scrolled / total : 0;
      progress = Math.max(0, Math.min(1, progress));

      for (var i = 0; i < rows.length; i++) {
        var startX = i % 2 === 0 ? maxTranslate : 0;
        var endX = i % 2 === 0 ? 0 : maxTranslate;
        var current = startX + (endX - startX) * progress;
        rows[i].style.transform = 'translateX(' + current + '%)';
      }
    }

    updateScroll();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-at-scroll-promo]').forEach(initScrollPromo);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
